<mat-expansion-panel class="expansion-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'MEETING_DETAILS.MEETING_DETAILS' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <div class="data-label">{{ 'MEETING_DETAILS.MEETING_TITLE' | translate }}</div>
  <div class="data-value">{{ conversation()?.title }}</div>
  <div class="data-label">{{ 'COMMON.DATE' | translate }}</div>
  <div class="data-value">{{ conversation()?.meetingDate | date: 'MMMM d, yyyy' }}</div>
  <div class="data-label">{{ 'COMMON.TIME' | translate }}</div>
  <div class="data-value">{{ conversation()?.meetingDate | date: 'h:mm a' }}</div>
  <div class="data-label">{{ 'COMMON.DURATION' | translate }}</div>
  <div class="data-value">{{ duration() | date: 'H:mm:ss' : 'UTC' }}</div>
  <div class="data-label">{{ 'MEETING_DETAILS.SCHEDULED_ON' | translate }}</div>
  <div class="data-value">{{ conversation().source | meetingAnalysisSource | translate }}</div>
</mat-expansion-panel>
<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'COMMON.KEYWORDS' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-chip-listbox>
    @for (keyword of conversation()?.keywords; track keyword) {
      <mat-chip>{{ keyword }}</mat-chip>
    }
  </mat-chip-listbox>
</mat-expansion-panel>
<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="title-with-score">
        <span>{{ 'MEETING_DETAILS.SENTIMENT_SCORE' | translate }}</span>
        <span
          ><meeting-analysis-score-badge
          [score]="conversation()?.sentiment || 0"
          [maxScore]="10"
          ></meeting-analysis-score-badge
        ></span>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    {{ conversation()?.sentimentExplanation }}
  </div>
</mat-expansion-panel>
<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="title-with-score">
        <span>{{ 'MEETING_DETAILS.RAVEN_SCORE' | translate }}</span>
        <span
          ><meeting-analysis-score-badge
          [score]="conversation()?.salesScore || 0"
          [maxScore]="25"
          ></meeting-analysis-score-badge
        ></span>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    {{ conversation()?.salesScoreExplanation }}
  </div>
</mat-expansion-panel>
<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'COMMON.GUESTS' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <div class="data-label">
      {{ ('COMMON.CONTACTS' | translate) + ' (' + (externalAttendeesContactIds()?.length || 0) + ')' }}
    </div>
    <div class="data-value attendees">
      <meeting-analysis-participants [contactIds]="externalAttendeesContactIds()"></meeting-analysis-participants>
    </div>
    <div class="data-label">
      {{ ('MEETING_DETAILS.TEAM_MEMBERS' | translate) + ' (' + (internalAttendees()?.length || 0) + ')' }}
    </div>
    <div class="data-value attendees">
      <meeting-analysis-attendees [userIds]="internalAttendees()"></meeting-analysis-attendees>
    </div>
  </div>
</mat-expansion-panel>
